import { Navigate, NavigateProps, useParams } from "react-router-dom-7"

/**
 * Обертка вокруг `Navigate` с подстановкой текущих параметров
 * @param props
 */
export function NavigateWithParams({
	replace,
	to,
	...navProps
}: NavigateProps) {
	const params = useParams()

	for (let [key, value = ""] of Object.entries(params)) {
		if (key !== "*") key = ":" + key

		if (typeof to === "string") {
			to = to.replace(key, value)
		} else {
			to.pathname = to.pathname?.replace(key, value)
			to.search = to.search?.replace(key, value)
			to.hash = to.hash?.replace(key, value)
		}
	}

	return <Navigate replace={replace} to={to} {...navProps} />
}
